// extracted by mini-css-extract-plugin
export default {"actionBoxBtn":"tableActionsButtons_actionBoxBtn__TUJN-","button":"tableActionsButtons_button__pg0R7","declineButton":"tableActionsButtons_declineButton__fRxak"};